export default {
  name: 'CCardTxt',
  components: {},
  props: {
    info: {
      default: () => ({}),
      type: Object
    },
    imgStyle: {
      default: () => ({}),
      type: Object
    },
    titleStyle: {
      default: () => ({}),
      type: Object
    },
    descStyle: {
      default: () => ({}),
      type: Object
    },
    height: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleGo() {
      this.info.btn && window.open(this.info.btnurl);
    }
  }
};